mutation LeadResearchPromptUpdateMutation($input: LeadResearchPromptUpdateInput!) {
    leadResearchPromptUpdate(input: $input) {
        selectedFields
        businessContext
        idealCustomer
    }
}
